import React, { FC, ReactNode } from 'react';
import Taro from '@tarojs/taro';
import { OpenData } from '@tarojs/components';
import classNames from 'classnames';
import View from '../view';
import Image from '../image';
import Text from '../text';

const SIZE_CLASS = {
  large: 'large',
  normal: 'normal',
  small: 'small',
};

interface IAvatarProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 头像大小
   * @default normal
   */
  size?: 'large' | 'normal' | 'small';
  /**
   * 头像是否圆形
   * @default false
   */
  circle?: boolean;
  /**
   * 以文字形式展示头像
   */
  text?: string;
  /**
   * 头像图片地址
   */
  image?: string;
  /**
   * 是否为 openData 头像（此属性仅支持微信小程序，若为 true, 则展示为 OpenData 组件且 type 值为 userAvatarUrl）
   * @default false
   */
  openData?: boolean;
}

const Avatar: FC<IAvatarProps> = ({ className = '', size = 'normal', circle = false, text = '', image = '', openData = false }) => {
  const rootClassName = ['ink-avatar'];
  const iconSize = SIZE_CLASS[size || 'normal'];
  const classObject = {
    [`ink-avatar--${iconSize}`]: iconSize,
    'ink-avatar--circle': circle,
  };
  let elem: ReactNode;
  if (openData && Taro.getEnv() === Taro.ENV_TYPE.WEAPP) {
    elem = <OpenData type="userAvatarUrl" />;
  } else if (image) {
    elem = <Image className="ink-avatar__img" src={image} />;
  } else {
    elem = <Text className="ink-avatar__text">{text && text[0]}</Text>;
  }
  return <View className={classNames(rootClassName, classObject, className)}>{elem}</View>;
};

export default Avatar;
